import styled, { keyframes } from "styled-components";

export {
  SectionBlock,
  SectionHeader,
  SectionTitleWrapper,
  SectionTitleRow,
  SectionTitle,
  SectionSubtitle,
  InputGroup,
  Row,
  FlexInput,
  Footer,
  BackButton,
  Container,
} from "../StepRegistrationData/styles";

const scaleIn = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  80% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const PasswordForm = styled.form`
  width: 100%;
  max-width: 480px;
  margin: 10px auto 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SuccessCard = styled.div`
  width: 100%;
  max-width: 580px;
  margin: 0 auto;
  padding: 32px 24px;
  background-color: var(--white);
  border-radius: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const SuccessIconCircle = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background-color: rgba(39, 174, 96, 0.12);
  color: #27ae60;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  animation: ${scaleIn} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  box-shadow: 0px 4px 12px rgba(39, 174, 96, 0.15);

  svg {
    stroke-width: 2.5;
  }
`;

export const SuccessTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: var(--dark-gray);
  margin: 0;
`;

export const SuccessSubtitle = styled.p`
  font-size: 14px;
  color: var(--gray);
  line-height: 1.6;
  margin: 0;
`;

export const StepDescription = styled.p`
  font-size: 13.5px;
  color: var(--gray);
  margin: 0 0 16px 0;
  line-height: 1.4;
`;
